import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { ApplicationRouter, ProtectedRoute, Route, } from "@aviv-unified-frontend/runtime/router";
import { createUseAuthenticationGuard } from "@aviv-unified-frontend/runtime/authentication";
import { NotFoundErrorPage } from "../../pages/errors";
import { Loading } from "../Loading";
import { BRAND_CONFIGURATION } from "../../../configs/brands";
import { useGlobalStore } from "../../utils/useGlobalStore/useGlobalStore";
import { ClientSuspense } from "../ClientSuspense";
import { createRoutes } from "./createRoutes";
const RouteElement = ({ id, authorization, RemoteComponent, }) => {
    const { initialApplication, setApplicationId } = useGlobalStore();
    useEffect(() => {
        /**
         * <ScrollRestoration /> only works if using a data router
         * This is a native solution to scroll to the top of the page
         *
         * @see {@link https://reactrouter.com/en/main/components/scroll-restoration ScrollRestoration}
         */
        window.scrollTo({ top: 0, behavior: "auto" });
        setApplicationId(id);
    }, [id, setApplicationId]);
    const isPrerenderedApplication = initialApplication?.id === id;
    const isProtected = Boolean(BRAND_CONFIGURATION.authentication) &&
        authorization === "authenticated";
    const Component = isPrerenderedApplication ? (_jsx(initialApplication.Component, {})) : (_jsx(ClientSuspense, { children: _jsx(RemoteComponent, {}) }));
    return (_jsx(ProtectedRoute, { isProtected: isProtected, useGuards: createUseAuthenticationGuard({
            shouldRedirect: isProtected,
        }), ErrorComponent: NotFoundErrorPage, LoadingComponent: Loading, children: Component }));
};
const ROUTES = createRoutes();
export const Router = () => {
    return (_jsxs(ApplicationRouter, { children: [ROUTES.map(({ id, path, RemoteComponent, authorization }) => (_jsx(Route, { path: path, element: _jsx(RouteElement, { id: id, authorization: authorization, RemoteComponent: RemoteComponent }, `${id}-${path}`) }, `${id}-${path}`))), _jsx(Route, { path: "*", element: _jsx(NotFoundErrorPage, {}) })] }));
};
